<div class="container-fluid" *ngIf="swiperConfig !== undefined">
    <div class="row">
        <div class="col-12">
            <h2 class="section-heading-h2 section-heading-lg-mgn section-heading-bicolor text-center">
                Testimonios de instituciones&nbsp;<span class="enphasis">que reclutan con ProfeJOBS</span>
            </h2>
            <div class="equal-height-group swiper-container swiper-nav-bullets swiper-testimonials equal-height"
                style="margin: -30px 0 0 0;">
                <swiper [config]="swiperConfig" (swiper)="onSwiper($event)">
                                   
                    <ng-template swiperSlide class="swiper-slide">
                        <div class="equal-height swiper-card">
                            <div class="wrap-personal-info">
                                <div class="main-info">
                                    <div>
                                        <img src="images/testimonio-reclutador-1.jpeg" width="100" height="100"
                                            alt="Imagen de Soledad Solís, reclutadora de SIP" />
                                    </div>
                                    <div class="info-ctn">
                                        <span class="name">Soledad Solís</span>
                                        <span class="position">SIP </span>
                                    </div>
                                </div>
                                <div class="wrap-cite-icon">
                                    <img loading="lazy" src="images/icon-quote.png" class="icon"
                                        alt="ícono comillas de cita" />
                                </div>
                            </div>
                            <div class="wrap-cite">
                                <div>
                                    <cite>Estamos muy contentos con ProfeJOBS. Gracias a ellos hemos logrado
                                        reclutar muy buenos profesores. Valoramos la calidad de los
                                        postulantes y la rapidez con que nos permite responder a nuestros
                                        requerimientos</cite>
                                </div>
                            </div>
                        </div>
                    </ng-template>
                    <ng-template swiperSlide class="swiper-slide">
                        <div class="equal-height swiper-card">
                            <div class="wrap-personal-info">
                                <div class="main-info">
                                    <div>
                                        <img src="images/testimonio-reclutador-2.jpeg" width="100" height="100"
                                            alt="Imagen de Francisca Van de Wyngard, reclutadora de colegio San Benito" />
                                    </div>
                                    <div class="info-ctn">
                                        <span class="name">Francisca Van de Wyngard</span>
                                        <span class="position">Colegio San Benito</span>
                                    </div>
                                </div>
                                <div class="wrap-cite-icon">
                                    <img loading="lazy" src="images/icon-quote.png" class="icon"
                                        alt="ícono comillas de cita" />
                                </div>
                            </div>
                            <div class="wrap-cite">
                                <div>
                                    <cite>La plataforma es muy intuitiva y permite precisar muy bien lo que
                                        uno necesita. Además, la calidad de los postulantes es muy superior
                                        a los de otros portales de empleo.</cite>
                                </div>
                            </div>
                        </div>
                    </ng-template>
                </swiper> 
                <div id="swiper-employer-testimony" class="swiper-pagination"></div>
                <div class="controls-swiper-wrapper-2">
                    <div id="swiper-employer-testimony-prev" class="swiper-button-prev swiper-card-prev"></div>
                    <div id="swiper-employer-testimony-next" class="swiper-button-next swiper-card-next"></div>
                </div>
            </div>
        </div>
    </div>
</div>